module.exports = function (details) {
  return "<div id=\"game-menu\" class=\"game-menu\">".concat(details, "</div>");
};